/** Height of fixed mobile bottom nav (matches MobileBottomNav). */
export const MOBILE_NAV_HEIGHT = '4.25rem';

/** Bottom offset for sticky CTAs above mobile nav. */
export const MOBILE_STICKY_BOTTOM =
  `calc(${MOBILE_NAV_HEIGHT} + env(safe-area-inset-bottom, 0px))`;

/** Standard page padding when using <Header /> (top spacer is in Header). */
export const APP_PAGE_SHELL =
  'pt-4 sm:pt-6 pb-[calc(4.25rem+env(safe-area-inset-bottom,0px))] lg:pb-16';

/** Extra bottom room when page also has its own sticky footer on mobile. */
export const APP_PAGE_SHELL_WITH_STICKY =
  'pt-4 sm:pt-6 pb-[calc(11rem+env(safe-area-inset-bottom,0px))] lg:pb-28';

/** Accessible minimum touch target for primary actions. */
export const BTN_TOUCH =
  'min-h-[48px] inline-flex items-center justify-center';
